export default __webpack_public_path__ + "static/media/sofie.21991978.jpg";